import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import jaTranslations from './locales/ja.json';

type TranslationKeys = keyof typeof enTranslations;

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
    defaultNS: 'translation';
    resources: {
      translation: typeof enTranslations;
    };
  }

  interface TFunction {
    (key: TranslationKeys | string, options?: any): string;
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      ja: {
        translation: jaTranslations,
      },
    },
    // ブラウザ言語検出の設定
    detection: {
      // 検出に使用する方法の優先順位
      order: ['navigator', 'localStorage', 'htmlTag'],
      
      // 検出したい言語のマッピング
      convertDetectedLanguage: (lng: string) => {
        console.log('🌐 Detected browser language:', lng);
        
        // 日本語のみ日本語表示
        if (lng.startsWith('ja')) {
          console.log('🇯🇵 Japanese detected → Japanese site');
          return 'ja';
        }
        
        // その他すべての言語（英語、韓国語、中国語、フランス語など）は英語表示
        console.log('🌍 Non-Japanese language detected → English site');
        return 'en';
      },
      
      // ローカルストレージのキー名
      caches: ['localStorage'],
    },
    
    // サポートする言語のホワイトリスト
    supportedLngs: ['en', 'ja'],
    
    // 検出が失敗した場合のフォールバック言語
    fallbackLng: 'en',
    
    // デバッグモード（開発時のみ）
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
  });

// 言語変更時のログ（開発時のみ）
if (process.env.NODE_ENV === 'development') {
  i18n.on('languageChanged', (lng) => {
    console.log('🌐 Language changed to:', lng);
    console.log('🌐 Browser languages:', navigator.languages);
  });
  
  // 初期化完了時のログ
  i18n.on('initialized', () => {
    console.log('🌐 i18n initialized with language:', i18n.language);
    console.log('🌐 Browser preferred languages:', navigator.languages);
    console.log('🌐 Primary browser language:', navigator.language);
    
    // 言語別の表示確認
    if (i18n.language === 'ja') {
      console.log('✅ サイト表示: 日本語版');
    } else {
      console.log('✅ Site display: English version');
    }
  });
}

export default i18n; 